<div class="banner" #askus>
  <button (click)="previous()" class="left-button">
    <i class="fas fa-chevron-left"></i>
  </button>

  <div [@openClose]="leftImage" class="wrapper">
    <img class="left-img" alt="Laywer" [src]="images[rightIndex]" />

    <div class="content-div" style="margin-bottom: 90px">
      <div class="content">
        <h3>{{ title[rightIndex] | transloco }}</h3>
        <h1>{{ heading[rightIndex] | transloco }}</h1>
        <h2>{{ text[rightIndex] | transloco }}</h2>
      </div>
    </div>
  </div>

  <div class="three-dots">
    <div
      class="dot"
      [ngClass]="{ 'colored-dot': currentImageIndex == 0 }"
      (click)="navigateTo(0)"
    ></div>
    <div
      class="dot"
      [ngClass]="{ 'colored-dot': currentImageIndex == 1 }"
      (click)="navigateTo(1)"
    ></div>
    <div
      class="dot"
      [ngClass]="{ 'colored-dot': currentImageIndex == 2 }"
      (click)="navigateTo(2)"
    ></div>
  </div>
  <button (click)="next()" class="right-button">
    <i class="fas fa-chevron-right"></i>
  </button>
</div>
